import { useOutletContext } from 'react-router-dom';

/**
 * Что оболочка кабинета (`AppShell`) отдаёт своим экранам через `<Outlet context>`.
 *
 * ⚠️ Выход — ОДИН, в оболочке (`handleLogout`): метка пушей с ожиданием, отзыв сессии на сервере, «вышел сам».
 * Экран «Ещё» и профиль куратора зовут его отсюда, а не держат свою копию — сторож `app/staffLogout.test.ts`.
 */
export type ShellNavItem = { to: string; labelKey: string; icon: string; badge?: 'notifications' };

export type ShellContext = {
  logout: () => Promise<void>;
  /** Пункты меню роли после всех фильтров оболочки (роль, выключатели, приложение). */
  navItems: ShellNavItem[];
  /** Непрочитанные уведомления — только у куратора, иначе 0. */
  unread: number;
};

export function useShellContext(): ShellContext {
  return useOutletContext<ShellContext>();
}
